import { forwardRef } from 'react';

const BaseButton = forwardRef(function BaseButton(
  { className = '', style, type, disabled = false, children, ...buttonProps },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={className}
      style={style}
      {...buttonProps}
    >
      {children}
    </button>
  );
});

export default BaseButton;
